<app-topbar></app-topbar>
<div class="layout-content">
	<router-outlet></router-outlet>
</div>


<p-dialog header="" [modal]="true" [(visible)]="visible" [style]="{ width: '55rem' }" closable="false" >
	<ng-template pTemplate="header">
		<h4>You have unread important messages!</h4>
	</ng-template>

	<p-accordion [multiple]="true">
		@for (m of $messages | async; track m; let i = $index) {
		<p-accordionTab>
			<p-header>
				<span>{{ m.title }}</span>
			</p-header>
			<ng-template pTemplate="content">
				<div [innerHTML]="m.content"></div>
				<div class="mt-2">
					<p-button i18n-label label="Mark as read" (onClick)="markAsRead(m.id, m.doctor ? true : false)" />
				</div>
			</ng-template>
		</p-accordionTab>
		}
	</p-accordion>

	<div class="flex justify-content-end gap-2 mt-2">
		<p-button i18n-label label="Close" severity="secondary" (onClick)="visible = false" />
	</div>
</p-dialog>
